<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/notification-templates', text: 'notificationTemplate_listTitle' },
                     {
                        url: '/notification-templates/' + data?.Id,
                        text: 'notificationTemplate_viewTitle'
                     }]"></app-breadcrumbs>

    <ng-container *ngIf="data">
        <header class="content-header">
            <h1>
                {{data.Name || '...'}}
            </h1>
        </header>

        <div class="data-value">
            <label>{{'notificationTemplate_lblType' | translate}}</label>
            <div>{{data.Type}}</div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblSender' | translate}}</label>
            <div>{{data.Sender}} ({{'notification_sendingMethod' + data.SendingMethod | translate | lowercase}})</div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblChannels' | translate}}</label>
            <div>
                <span *ngFor="let n of channels; let i = index">
                    <ng-container *ngIf="i > 0">,</ng-container>
                    {{'notification_channel' + n.name | translate}}
                    <ng-container *ngIf="n.required"> *</ng-container>
                </span>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblSubjectLV' | translate}}</label>
            <div>
                <ng-container *ngIf="data.SubjectLV; else noValue">
                    {{data.SubjectLV}}
                </ng-container>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblSubjectEN' | translate}}</label>
            <div>
                <ng-container *ngIf="data.SubjectEN; else noValue">
                    {{data.SubjectEN}}
                </ng-container>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblMessageLV' | translate}}</label>
            <div>
                <ng-container *ngIf="data.MessageLV; else noValue">
                    {{data.MessageLV}}
                </ng-container>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblMessageEN' | translate}}</label>
            <div>
                <ng-container *ngIf="data.MessageEN; else noValue">
                    {{data.MessageEN}}
                </ng-container>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblShortMessageLV' | translate}}</label>
            <div>
                <ng-container *ngIf="data.ShortMessageLV; else noValue">
                    {{data.ShortMessageLV}}
                </ng-container>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notificationTemplate_lblShortMessageEN' | translate}}</label>
            <div>
                <ng-container *ngIf="data.ShortMessageEN; else noValue">
                    {{data.ShortMessageEN}}
                </ng-container>
            </div>
        </div>
    </ng-container>

    <div class="form-actions">
        <button class="btn btn-outline" type="button" [routerLink]="['/notification-templates'] | localize">
            {{'close' | translate}}
        </button>
    </div>
</div>

<ng-template #noValue>{{'undefined' | translate}}</ng-template>
